import * as validator from 'validator';
function validateUUID(input) {
    var _a;
    var env = (_a = process.env.REACT_APP_ENV_NAME) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    var isDevOrQa = env === 'dev' || env === 'qa';
    if (isDevOrQa && input.startsWith('smoke-test')) {
        return;
    }
    if (!validator.isUUID(input)) {
        throw new Error("Format Validation Error: string is not a valid UUID");
    }
}
var validationHelper = { validateUUID: validateUUID };
export { validationHelper };
